module.exports = __webpack_public_path__ + "static/media/united-card.29d40256.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/video/united-card.jpg
// module id = 510
// module chunks = 0